<template>
  <v-container fluid>
    <v-card flat class="mx-auto">
      <v-card-title>
        <span>Admin Settings</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="settings" v-model="isValid">
          <v-row>
            <v-col cols="12" md="12" class="mt-n3">
              <div class="text-body-1 font-weight-bold">
                <span>Minor Settings</span>
              </div>
              <v-divider class="pb-3" />
            </v-col>
            <!-- add IBL link -->
            <v-col cols="12" md="12" class="mt-n3 px-8 py-0">
              <div
                class="d-flex"
                @click="iblShow = !iblShow"
                style="cursor: pointer"
              >
                <span class="primary--text font-italic">1. IBL Links </span>
                <v-icon size="16" color="primary">{{
                  iblShow ? "mdi-chevron-down" : "mdi-chevron-up"
                }}</v-icon>
              </div>
              <v-divider v-if="iblShow" />
            </v-col>
            <IBLLinks
              :editingIndex="editingIndex"
              :settingsFormData="settingsFormData"
              :saveSettings="saveSettings"
              v-if="iblShow"
            />
            <v-col cols="12" md="12" class="mt-n3 px-8 pb-0">
              <div @click="dashblShow = !dashblShow" style="cursor: pointer">
                <span class="primary--text font-italic"
                  >2. Dashboard Links
                </span>
                <v-icon size="16" color="primary">{{
                  dashblShow ? "mdi-chevron-down" : "mdi-chevron-up"
                }}</v-icon>
              </div>
              <v-divider v-if="dashblShow" />
            </v-col>
            <DashboardLinks
              :settingsFormData="settingsFormData"
              :saveSettings="saveSettings"
              v-if="dashblShow"
            />
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveSettings">
          <v-icon class="mr-1" size="15">mdi-content-save-all-outline</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import IBLLinks from "./iblLinks.vue";
import { helper } from "@/packages/dashboard/utils";
import DashboardLinks from "./DashboardLinks.vue";
export default {
  name: "AdminSettings",
  components: { IBLLinks, DashboardLinks },
  data() {
    return {
      isValid: false,
      editingIndex: -1,
      items: [],
      settingsFormData: {
        minor_settings: {
          ibl_link: [],
          selected_ibl_links: [],
          dashboard_links: [],
        },
        site_colors: [],
        site_installed_packages: [],
      },
      iblShow: true,
      dashblShow: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getSettings");
    });
  },
  computed: {
    rules() {
      return {};
    },
    settings() {
      return this.$store.getters["Administrator/administratorGetters"](
        "settings",
      );
    },
  },
  methods: {
    async saveSettings() {
      // this.editingIndex = -1;
      const data = {
        site_colors: JSON.stringify(
          this.settingsFormData.site_colors.length > 0
            ? this.settingsFormData.site_colors
            : this.colors,
        ),
        site_installed_packages: JSON.stringify(
          this.settingsFormData.site_installed_packages.length > 0
            ? this.settingsFormData.site_installed_packages
            : [],
        ),
        minor_settings: JSON.stringify(this.settingsFormData.minor_settings),
        id: this.settings ? this.settings.id : null,
      };
      if (this.settings.id) {
        console.log("passed");
        this.$store.dispatch(
          "Administrator/updateSettings",
          helper.prepareFormData(data),
        );
      } else {
        this.$store.dispatch(
          "Administrator/addSettings",
          helper.prepareFormData(data),
        );
      }
    },
    objectToArray(obj) {
      return Object.keys(obj).map((key) => {
        return { colorName: key, color: obj[key], menu: false };
      });
    },
  },
  watch: {
    settings: {
      handler: async function (val) {
        if (val) {
          this.settingsFormData.minor_settings =
            val && val.minor_settings
              ? JSON.parse(val.minor_settings)
              : this.settingsFormData.minor_settings;
          this.settingsFormData.site_colors =
            val && val.site_colors
              ? JSON.parse(val.site_colors)
              : this.objectToArray(this.$vuetify.theme.themes.light);
          this.settingsFormData.site_installed_packages =
            val && val.site_installed_packages
              ? JSON.parse(val.site_installed_packages)
              : [];
        }
      },
      deep: true,
    },
  },
};
</script>
